import { parrotApi } from '@libs/openapi';
import { isEqual } from 'lodash-es';
import { useEffect, useState } from 'react';
import { OpenapiClientParrotVault } from 'src/openapi/parrot-vault';
import { useAddress } from './use-address';
import { useRefreshTime } from './use-refresh';

export const useVaults = (query: OpenapiClientParrotVault.GetVaultVaultsQuery) => {
  const { refreshTime } = useRefreshTime();
  const address = useAddress();
  const [vaults, setVaults] = useState<OpenapiClientParrotVault.GetVaultVaultsResponse>();
  const [pre, setPre] = useState<OpenapiClientParrotVault.GetVaultVaultsQuery>();

  const getVaults = async () => {
    if (!isEqual(query, pre)) {
      setVaults(undefined);
    }

    const result = await parrotApi.get('/vault/vaults', {
      query: {
        ...query,
        page: 1,
        limit: 100,
        owner: address,
      },
    });
    setVaults(result);
    setPre(query);
  };

  useEffect(() => {
    let timer: NodeJS.Timeout | undefined;
    const loop = () => {
      getVaults();
      timer = setTimeout(() => {
        loop();
      }, 60 * 1000);
    };
    loop();
    return () => {
      clearTimeout(timer);
    };
  }, [query.direction, query.sort, query.tokens?.length, address, query.protocol, refreshTime]);

  return {
    vaults,
  };
};

export const useVaultById = (vaultId: string) => {
  const { refreshTime } = useRefreshTime();
  const address = useAddress();
  const [vault, setVault] = useState<OpenapiClientParrotVault.GetVaultVaultsByIdResponse>();

  const getVaults = async () => {
    const result = await parrotApi.get('/vault/vaults/{id}', {
      query: {
        owner: address,
      },
      params: {
        id: vaultId,
      },
    });
    setVault(result);
  };

  useEffect(() => {
    getVaults();
  }, [vaultId, address, refreshTime]);

  return {
    vault,
  };
};
